import React from 'react';
import { FDHeadlineText, FDDisplayText } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';

export const HeroText = ({ value }) => {
  const isMobile = useMobileLayout();
  return isMobile ? <FDHeadlineText value={value} size="lg" align="center" /> : <FDDisplayText value={value} size="lg" align="center" />;
};
